export class CapacityResultEntity {
  public userId!: string;
  public baseCapacity!: number;
  public temporaryCapacity!: number | null;
  public temporaryCapacityExpiresOn!: string | null;
  public effectiveCapacity!: number;
}
